import type { ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'
import { cn } from '../../utils/cn.ts'

export function Table(props: ComponentProps<'div'> & { columns?: string }) {
  const [local, rest] = splitProps(props, ['class', 'columns', 'style'])

  return (
    <div
      class={cn('w-full text-sm grid', local.class)}
      style={{
        'grid-template-columns': local.columns ?? 'repeat(auto-fill, minmax(0, 1fr))',
        ...(typeof local.style === 'object' ? local.style : {}),
      }}
      role="table"
      {...rest}
    />
  )
}

export function TableRow(props: ComponentProps<'div'>) {
  const [local, rest] = splitProps(props, ['class'])

  return (
    <div
      class={cn('col-span-full grid grid-cols-subgrid border-b transition-colors hover:bg-muted/50 last:border-b-0', local.class)}
      role="row"
      {...rest}
    />
  )
}

export function TableCell(props: ComponentProps<'div'>) {
  const [local, rest] = splitProps(props, ['class', 'children'])

  return (
    <div class={cn('p-2 min-w-0', local.class)} role="cell" {...rest}>
      {local.children}
    </div>
  )
}
